import GroupInfoDropdown from '../../../ComponentLibrary/oc-group-info-dropdown';
import RichText from '../RichText';

const ResultHeaderComponent = ({ headerData: { hideHeading, text, alt, badge, collapsible, ctaLabel, label } }) => {
  if (hideHeading) {
    return null;
  }
  return (
    <GroupInfoDropdown alt={alt} badge={badge} collapsible={collapsible} ctaLabel={ctaLabel} label={label}>
      <RichText content={text} />
    </GroupInfoDropdown>
  );
};

export default ResultHeaderComponent;
